"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryParams = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
/**
 * Hook to manage query params
 * @returns A Params object with a polyfill to update param values
 */
const useQueryParams = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const [params, setParams] = (0, react_1.useState)(new URLSearchParams(location.search));
    const navigate = (0, react_router_dom_1.useNavigate)();
    const oldSet = params.set.bind(params);
    params.set = (name, value) => {
        if (value !== params.get(name)) {
            oldSet(name, value);
            navigate({ ...location, search: params.toString() }, { replace: true });
            setParams(new URLSearchParams(params.toString()));
        }
    };
    return params;
};
exports.useQueryParams = useQueryParams;
//# sourceMappingURL=use-query-params.js.map